import { ShieldCheck, Send } from "lucide-react";
import { CTA_URL } from "../data/site";
import { trackSubscribe } from "../lib/pixel";
import Reveal from "./Reveal";

export default function ClosingCTA() {
  return (
    <section id="cara-bergabung" data-testid="closing-cta" className="relative scroll-mt-24 overflow-hidden py-20 md:py-28">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald/15 blur-[140px]"
      />
      <div className="relative mx-auto max-w-2xl px-5 text-center sm:px-8">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-goldlight/40 bg-goldlight/10 px-4 py-2 text-[10px] font-bold tracking-[0.28em] text-goldlight sm:text-xs">
            <ShieldCheck className="h-4 w-4" />
            KHUSUS AKUN BOOSTER
          </span>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-7 text-3xl font-black leading-tight text-cream sm:text-4xl md:text-5xl">
            Mau dapatkan hadiah-hadiah ini?
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mx-auto mt-5 max-w-xl text-sm font-light leading-relaxed text-sage md:text-base">
            Pastikan kamu pakai akun BOOSTER, ya! Pelajari persyaratan program sebelum mulai dan tetap trading sesuai
            rencana kalian.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mx-auto mt-9 max-w-xl rounded-2xl border border-emerald/20 bg-forest p-5 text-sm font-light leading-relaxed text-sage">
            Konfirmasi jenis akun, ketentuan rebate, dan syarat reward kepada admin sebelum bergabung.
          </div>
        </Reveal>
        <Reveal delay={0.32}>
          <a
            data-testid="closing-cta-button"
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackSubscribe}
            className="group mt-9 inline-flex items-center justify-center gap-2.5 rounded-full bg-gold px-7 py-4 text-sm font-bold text-night shadow-[0_20px_50px_-15px_rgba(212,175,55,0.5)] transition-all duration-300 hover:scale-[1.03] hover:bg-goldlight sm:text-base"
          >
            Klik Sini Buat Klaim FREE REBATE 15 USD Per Lot
            <Send className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
